import { store } from '../../state/store';
var texts = store.getState().properties.data.textsFile;
export default (function (copyType) {
  var copys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return copys ? copys[copyType] || '' : texts[copyType] || '';
});